'use client'

import NoResultTemplate from 'ui/NoResultTemplate'
import FederationRowCard from 'components/cards/FederationRowCard'
import { useTranslation } from 'components/providers/TranslationProvider'

interface ExploreFederationsPageClientProps {
    federations: (IFederation & {
        mostRecentMatchDate?: string | null // ISO string from server
        mostRecentSeasonStartDate?: string | null // ISO string from server
        matchCount?: number
        competitionCount?: number
    })[]
}

/**
 * ExploreFederationsPageClient - Client Component
 *
 * Handles:
 * - Rendering federations list in row format
 * - Translation for empty state
 */
const ExploreFederationsPageClient = ({ federations }: ExploreFederationsPageClientProps) => {
    const { t, isLoading: translationsLoading } = useTranslation()

    // Show loading state while translations are loading
    if (translationsLoading || !t) {
        return <div className='text-center py-8'>Loading...</div>
    }

    return (
        <div className='flex-1 overflow-hidden md:-mx-6 lg:-mx-8'>
            <div className='flex flex-col gap-2 md:gap-3 px-1 sm:px-1.5 md:px-2 lg:px-3 w-full'>
                {federations?.map(federation => (
                    <FederationRowCard key={federation.id} federation={federation} />
                ))}
            </div>
            {((federations && federations?.length < 1) || !federations) && <NoResultTemplate />}
        </div>
    )
}

export default ExploreFederationsPageClient
